import mainImg from "assets/images/v96/main.webp"
import mainImgRu from "assets/images/v96/main-ru.png"

export const v96Config = {
  picture: {
    en: mainImg,
    ru: mainImgRu,
  },
}
